(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lomamo-kinderkamers"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(scope) {
    scope.querySelectorAll('[data-lomamo-rooms]').forEach(root => {
      if(root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const labels = JSON.parse(root.querySelector('[data-room-labels]').textContent);
      const cards = Array.from(root.querySelectorAll('[data-room-card]'));
      const add = root.querySelector('[data-room-add]');
      const feedback = root.querySelector('[data-room-feedback]');
      const format = new Intl.NumberFormat(labels.locale, {style:'currency',currency:labels.currency});
      const selections = () => {
        const items = new Map();
        cards.forEach(card => {
          if(!card.querySelector('[data-room-check]').checked) return;
          const option = card.querySelector('select').selectedOptions[0];
          const qty = Number(card.querySelector('[data-room-quantity]').value);
          if(option.dataset.available !== 'true' || !Number.isInteger(qty) || qty < 1 || qty > 99) return;
          const id = Number(option.value);
          const prior = items.get(id);
          items.set(id,{id,quantity:(prior?.quantity || 0)+qty,price:Number(option.dataset.price)});
        });
        return Array.from(items.values());
      };
      function refresh() {
        const items = selections();
        const total = items.reduce((sum,item) => sum+item.price*item.quantity,0);
        root.querySelector('[data-room-summary]').textContent = items.length ? items.length+' '+labels.selected+' · '+format.format(total/100) : labels.empty;
        add.disabled = items.length === 0;
      }
      cards.forEach(card => {
        const select = card.querySelector('select');
        select.addEventListener('change',() => {
          const option=select.selectedOptions[0];
          card.querySelector('[data-room-price]').textContent=option.dataset.money;
          const compare=card.querySelector('[data-room-compare]');compare.hidden=Number(option.dataset.compare)<=Number(option.dataset.price);compare.textContent=option.dataset.compareMoney;
          const img=card.querySelector('img');
          img.removeAttribute('srcset');img.src=option.dataset.image;
          card.querySelectorAll('[data-product-link]').forEach(link=>{const url=new URL(link.href);url.searchParams.set('variant',option.value);link.href=url.href;});
          refresh();
        });
        card.addEventListener('change',refresh);
        card.addEventListener('input',refresh);
      });
      add.addEventListener('click',async()=>{
        if(cards.some(card => card.querySelector('[data-room-check]').checked && !card.querySelector('[data-room-quantity]').reportValidity())) return;
        const items=selections().map(({id,quantity})=>({id,quantity}));
        if(!items.length)return;
        add.disabled=true;feedback.textContent=labels.busy;
        try{
          const route=window.Shopify?.routes?.root || '/';
          const result=await fetch(route+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
          if(!result.ok)throw new Error();
          window.location.assign(route+'cart');
        }catch(error){feedback.textContent=labels.error;refresh();}
      });
      refresh();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
